<template>
    <multiselect
        v-bind="configuration"
        :value="selectVal"
        :tabindex="0"
        :class="{ 'has-selection': hasSelection }"
        :dusk="'dusk_' + name"
        :placeholder="placeholder"
        :options="preparedOptions"
        :allow-empty="allowEmpty"
        :show-labels="showLabels"
        :multiple="multiple"
        :track-by="trackBy"
        :label="label"
        class="jgile-multiselect"
        @input="onChange"
    >
        <slot name="clear"></slot>
        <span slot="caret">
            <i class="fal fa-chevron-down"></i>
        </span>
    </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    components: { Multiselect },
    props: {
        value: {},
        options: {
            required: true,
        },
        name: {
            stype: String,
            default: '',
        },
        placeholder: {
            stype: String,
            default: null,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        groupLabel: {
            stype: String,
            required: false,
        },
        groupValues: {
            required: false,
        },
        showLabels: {
            type: Boolean,
            default: false,
        },
        allowEmpty: {
            type: Boolean,
            default: true,
        },
        sort: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: 'name',
        },
        trackBy: {
            type: String,
            default: 'id',
        },
    },
    data() {
        return {
            configuration: {},
            selection: null,
        };
    },
    created() {
        if (this.groupLabel && this.groupValues) {
            this.configuration.groupLabel = this.groupLabel;
            this.configuration.groupValues = this.groupValues;
        }
    },
    computed: {
        /**
         *
         * @returns {*}
         */
        hasSelection() {
            if (this.multiple) {
                return this.selectVal && !_.isEmpty(this.selectVal);
            }

            return this.selectVal && _.get(this.selectVal, 'id');
        },

        /**
         * Parses various options formats to a standard format.
         * Possible formats: [val1,val2,val3], {name1:val1, name2:val2}, [{name: name, id: id}]
         * @returns {*}
         */
        preparedOptions() {
            let options = this.options;

            // [val, val val]
            if (_.isArray(options) && !_.isObject(options[0])) {
                options = _.map(this.options, (val) => {
                    return { name: val, id: val };
                });
            }

            // {name: val, name: val}
            if (_.isObject(options) && !_.isArray(options)) {
                options = _.map(this.options, (name, id) => {
                    return { name: name, id: id };
                });
            }

            if (this.sort) {
                options = _.sortBy(options, ['name'], ['asc']);
            }

            return options;
        },

        /**
         *
         * @returns {*}
         */
        selectVal() {
            const _this = this;
            let found;
            let options = this.preparedOptions;

            if (this.groupLabel && this.groupValues) {
                options = _.flatten(
                    _.map(options, (group) => {
                        return _.get(group, this.groupValues);
                    }),
                );
            }

            if (this.multiple) {
                let stringValues = _.map(_this.value, (item) => _.toString(item));
                found = _.filter(options, (o) => {
                    return _.includes(stringValues, _.toString(o.id));
                });
            } else {
                found = _.find(options, function (o) {
                    return _.toString(o.id) === _.toString(_this.value);
                });
            }

            return found ? found : null;
        },
    },
    methods: {
        onChange(selectedOption) {
            let emitVal;

            if (this.multiple) {
                emitVal = _.has(selectedOption, 'id')
                    ? [_.get(selectedOption, 'id')]
                    : _.map(selectedOption, function (item) {
                        return item.id;
                    });
            } else {
                emitVal = _.get(selectedOption, 'id', null);
            }

            this.$emit('change', emitVal);
            this.$emit('input', emitVal);
        },
    },
};
</script>
